module.exports = __webpack_public_path__ + "static/media/am115_shuttle.9d83a4fa.png";